/**
 * BulkActionBar.tsx — Appears when rows are selected in a DataTable.
 * Shows count and bulk actions (currently delete + clear).
 */
import React from 'react';

interface BulkActionBarProps {
  count: number;
  label: string;
  onDelete: () => void;
  onClear: () => void;
  deleting?: boolean;
}

export default function BulkActionBar({ count, label, onDelete, onClear, deleting }: BulkActionBarProps): React.JSX.Element {
  return (
    <div className="flex items-center gap-4 rounded-2xl border border-red-200 bg-red-50 px-5 py-3">
      <span className="text-sm font-medium text-red-700">
        {count} {label}{count !== 1 ? 's' : ''} selected
      </span>
      <button
        onClick={onDelete}
        disabled={deleting}
        className="rounded-full bg-red-600 px-4 py-1.5 text-xs font-semibold text-white hover:bg-red-700 disabled:opacity-50"
      >
        {deleting ? 'Deleting…' : `Delete ${count > 1 ? 'Selected' : label.charAt(0).toUpperCase() + label.slice(1)}`}
      </button>
      <button onClick={onClear} className="ml-auto text-xs text-red-500 hover:text-red-700">
        Clear selection
      </button>
    </div>
  );
}
